import type { Chord } from 'svguitar';

export const BChords: Record<string, Chord> = {
  B: {
    fingers: [
      [2, 4, '4'],
      [3, 4, '3'],
      [4, 4, '2'],
      [6, 'x'],
    ],
    barres: [
      {
        fromString: 5,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'B',
    position: 0,
  },
  B9: {
    fingers: [
      [3, 4, '4'],
      [4, 4, '3'],
      [6, 'x'],
    ],
    barres: [
      {
        fromString: 5,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'B9',
    position: 0,
  },
  B7: {
    fingers: [
      [2, 4, '4'],
      [4, 4, '3'],
      [6, 'x'],
    ],
    barres: [
      {
        fromString: 5,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'B7',
    position: 0,
  },
  Bm: {
    fingers: [
      [2, 3, '2'],
      [3, 4, '4'],
      [4, 4, '3'],
      [6, 'x'],
    ],
    barres: [
      {
        fromString: 5,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'Bm',
    position: 0,
  },
  Bm7: {
    fingers: [
      [2, 3, '2'],
      [4, 4, '3'],
      [6, 'x'],
    ],
    barres: [
      {
        fromString: 5,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'Bm7',
    position: 0,
  },
};
